import { FC } from 'react';
import { FilterList, FilterListItem, useListContext } from 'react-admin';
import DateRangeIcon from '@material-ui/icons/DateRange';
import dayjs from 'dayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box } from '@mui/material';

const DateSideFilter: FC = () => {
  const { filterValues, setFilters } = useListContext();
  const today = dayjs();

  const handleCustomDateChange = (type: 'start' | 'end', value: any) => {
    const newFilters = { ...filterValues };
    if (type === 'start') {
      if (value) {
        newFilters.startDate = dayjs(value).format('YYYY-MM-DDTHH:mm:ss[Z]');
      } else {
        delete newFilters.startDate;
      }
    } else {
      if (value) {
        newFilters.endDate = dayjs(value)
          .endOf('day')
          .format('YYYY-MM-DDTHH:mm:ss[Z]');
      } else {
        delete newFilters.endDate;
      }
    }
    newFilters.dateRangeType = 'custom';
    setFilters(newFilters, undefined);
  };

  return (
    <FilterList label="Billing Date" icon={<DateRangeIcon />}>
      <FilterListItem
        label="Last 7 days"
        value={{
          startDate: today
            .subtract(7, 'day')
            .startOf('day')
            .format('YYYY-MM-DDTHH:mm:ss[Z]'),
          endDate: today.endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]'),
          dateRangeType: 'last7days',
        }}
      />
      <FilterListItem
        label="Last Week"
        value={{
          startDate: today
            .subtract(7, 'day')
            .startOf('week')
            .format('YYYY-MM-DDTHH:mm:ss[Z]'),
          endDate: today
            .subtract(7, 'day')
            .endOf('week')
            .format('YYYY-MM-DDTHH:mm:ss[Z]'),
          dateRangeType: 'lastWeek',
        }}
      />
      <FilterListItem
        label="Last Month"
        value={{
          startDate: today
            .subtract(1, 'month')
            .startOf('month')
            .format('YYYY-MM-DDTHH:mm:ss[Z]'),
          endDate: today
            .subtract(1, 'month')
            .endOf('month')
            .format('YYYY-MM-DDTHH:mm:ss[Z]'),
          dateRangeType: 'lastMonth',
        }}
      />
      <FilterListItem
        label="Custom"
        value={{
          ...filterValues,
          dateRangeType: 'custom',
        }}
      />
      {filterValues.dateRangeType === 'custom' && (
        <Box sx={{ mt: 1, pt: 1, pb: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Start date"
              value={
                filterValues.startDate ? dayjs(filterValues.startDate) : null
              }
              onChange={(val) => handleCustomDateChange('start', val)}
              maxDate={
                filterValues.endDate ? dayjs(filterValues.endDate) : today
              }
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                  sx: { mb: 2 },
                },
              }}
            />
            <DatePicker
              label="End date"
              value={filterValues.endDate ? dayjs(filterValues.endDate) : null}
              onChange={(val) => handleCustomDateChange('end', val)}
              minDate={
                filterValues.startDate
                  ? dayjs(filterValues.startDate)
                  : undefined
              }
              maxDate={today}
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      )}
    </FilterList>
  );
};

export default DateSideFilter;
